module.exports = __webpack_public_path__ + "static/Image_Asset_6-e84b7ef4763c46e888c62fa3cac55aa0.png";